<template>
  <div class="profile-tab-wrap">
    <a-tabs
      :default-active-key="routeName"
      v-if="exceptCollegeCoach"
      @tabClick="handleTabClick"
    >
      <a-tab-pane key="athlete" tab="Players" v-if="isPlayer">
        <FavouriteIndex />
      </a-tab-pane>
      <a-tab-pane v-if="exceptClubHeadCoach()" key="college" tab="Colleges">
        <FavouriteIndex />
      </a-tab-pane>
      <a-tab-pane
        v-if="exceptClubHeadCoach()"
        key="college_event"
        tab="College Events"
      >
        <FavouriteIndex college-event />
      </a-tab-pane>
      <a-tab-pane key="club_team" tab="Clubs">
        <FavouriteIndex />
      </a-tab-pane>
      <a-tab-pane key="club_event" tab="Club Events">
        <FavouriteIndex club-event />
      </a-tab-pane>
    </a-tabs>
    <a-tabs :default-active-key="routeName" v-else @tabClick="handleTabClick">
      <a-tab-pane key="athlete" tab="Players" v-if="isPlayer">
        <FavouriteIndex />
      </a-tab-pane>
      <a-tab-pane key="club_team" tab="Clubs">
        <FavouriteIndex />
      </a-tab-pane>
      <a-tab-pane key="club_event" tab="Club Events">
        <FavouriteIndex club-event />
      </a-tab-pane>
      <a-tab-pane v-if="exceptClubHeadCoach()" key="college" tab="Colleges">
        <FavouriteIndex />
      </a-tab-pane>
      <a-tab-pane
        v-if="exceptClubHeadCoach()"
        key="college_event"
        tab="College Events"
      >
        <FavouriteIndex college-event />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import FavouriteIndex from "./favourite";
import { Base } from "@/models";

export default {
  components: {
    FavouriteIndex
  },
  methods: {
    handleTabClick(e) {
      this.$router.push(`/${Base.profileId()}/favourites/${e}`);
    }
  },
  computed: {
    isPlayer() {
      return JSON.parse(localStorage["user-permissions"]) !== "player";
    },
    exceptCollegeCoach() {
      return Base.userType() != "collegeCoach";
    },
    routeName() {
      const routes = this.$route.path.split("/");
      return routes[routes.length - 1];
    }
  }
};
</script>
